import React, { useState } from 'react';
import styled from 'styled-components';
import TooltipLabel from './TooltipLabel';
import { PlayArrow } from '@mui/icons-material';

interface Props {
    $isExpanded: boolean;
}

interface HeaderProps {
    $isExpanded: boolean;
    $isLastPhase?: boolean;
}

const StandardFormBoxContainer = styled.div<Props>`
    width: 100%;
    border: 2px solid #58585A;
    border-radius: 30px;
    overflow: visible;
`;

const StandardHeader = styled.div<Props>`
    display: flex;
    align-items: center;
    justify-content: center; 
    position: relative;
    font-size: 1rem;
    font-weight: 500;
    padding: 1rem;
    z-index: 1;
    background: #E9ECF6;
    cursor: pointer;
    border-radius: ${({ $isExpanded }) => ($isExpanded ? '30px 30px 0px 0px' : '30px')};
    border-bottom: ${({ $isExpanded }) => ($isExpanded ? '2px solid #58585A' : '')};
`;

const StandardContent = styled.div<Props>`
    max-height: ${({ $isExpanded }) => ($isExpanded ? '1250px' : '0')};
    opacity: ${({ $isExpanded }) => ($isExpanded ? '1' : '0')};
    transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
    background: #FFFFFF;
    border-radius: 0px 0px 30px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const OutputFormBoxContainer = styled.div<Props>`
    width: 100%;
    overflow: visible;
`;

const OutputHeader = styled.div<HeaderProps>`
    display: flex;
    align-items: center;
    justify-content: center; 
    position: relative;
    font-size: 1rem;
    font-weight: 500;
    padding: 0.5rem;
    z-index: 1;
    background: #E9ECF6;
    cursor: pointer;
    border-bottom: ${({ $isExpanded }) => ($isExpanded ? '1px solid #58585A' : '')};
    border-radius: ${({ $isExpanded, $isLastPhase }) => (!$isExpanded && $isLastPhase ? '0px 0px 29px 28px' : '')};
    overflow: visible;
    `;

const OutputContent = styled.div<Props>`
    max-height: ${({ $isExpanded }) => ($isExpanded ? '1250px' : '0')};
    opacity: ${({ $isExpanded }) => ($isExpanded ? '1' : '0')};
    transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
    background: #FFFFFF;
    border-radius: 0px 0px 30px 30px;
`;

const RotatingPlayArrow = styled(PlayArrow) <{ $isExpanded: boolean }>`
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: ${({ $isExpanded }) => $isExpanded ? 'translateY(-50%) rotate(90deg)' : 'translateY(-50%) rotate(0deg)'};
    transition: transform 0.3s ease !important;
    cursor: pointer;
`;

interface FormBoxDropdownProps {
    variant: "standard" | "output";
    headerContent?: React.ReactNode;
    children?: React.ReactNode;
    isLastPhase?: boolean;
    tooltip?: string;
}

const FormBoxDropdown: React.FC<FormBoxDropdownProps> = ({ variant, headerContent, children, isLastPhase, tooltip }) => {
    const [isExpanded, setIsExpanded] = useState(variant === "standard" ? true : false);

    return (
        <>
            {variant === "standard" &&
                <StandardFormBoxContainer $isExpanded={isExpanded} >
                    <StandardHeader $isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                        <div>{headerContent}</div>
                        <RotatingPlayArrow fontSize='medium' $isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} />
                    </StandardHeader>
                    <StandardContent $isExpanded={isExpanded}>
                        {isExpanded && children}
                    </StandardContent>
                </StandardFormBoxContainer>
            }

            {variant === "output" &&
                <OutputFormBoxContainer $isExpanded={isExpanded} >
                    <OutputHeader $isLastPhase={isLastPhase} $isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                        <div>
                            <TooltipLabel label={`${headerContent}`} tooltip={tooltip || ""} />
                        </div>
                        <RotatingPlayArrow fontSize='medium' $isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} />
                    </OutputHeader>
                    <OutputContent $isExpanded={isExpanded}>
                        {isExpanded && children}
                    </OutputContent>
                </OutputFormBoxContainer>
            }
        </>
    );
}

export default FormBoxDropdown;
